import React, { createContext } from 'react';

const context = createContext({ data: {}, setData: {} });

export default context;